<div class="host-hour-room-order">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "word.house" | translate }}
      <!-- Properties -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div
            class="ant-select ant-select-show-arrow ant-select-single ant-select-lg w-full"
            (click)="displayPickerModal(house)"
          >
            <div class="ant-select-selector">
              <span class="ant-select-selection-item">
                {{ house?.title }} （{{ house?.check_in | dateformat : ["MD"] }}）
              </span>
              <div class="ant-select-arrow">
                <i nz-icon nzType="down" nzTheme="outline"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form" *ngIf="listOfHourOrder?.length">
    <div class="v4-layout-form-title">{{ "component.sidebar.order_form_title_calendar" | translate }}</div>
    <div class="py-3">
      <host-hour-room-calendar
        [listOfOrder]="listOfHourOrder"
        [checkinReservation]="checkinOrder"
        [checkoutReservation]="checkoutOrder"
        (onReservationClick)="onClickReservation($event)"
      ></host-hour-room-calendar>
    </div>
  </div>

  <div class="v4-layout-form" [formGroup]="form">
    <div class="v4-layout-form-title">
      {{ "component.sidebar.order_form_title_info" | translate }}
    </div>

    <div class="v4-layout-field">
      <span class="v4-layout-field-label require">
        {{ "component.sidebar.order_form_item_customer" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative">
          <host-input-with-error
            class="w-full"
            [showError]="checking && form.get('name').invalid"
            [i18nErrorKey]="'errorText.name'"
          >
            <input
              nz-input
              type="text"
              nzSize="large"
              formControlName="name"
              [readonly]="isExistedGuest"
              [attr.placeholder]="'placeholder.tenant_name' | translate"
              (compositionstart)="compositionstart('name')"
              (compositionend)="compositionend('name')"
              (input)="checkIfHasDuplicateGuest('name')"
            />
            <span
              class="guest-icon"
              [class.highlight]="hasDuplicateGuest"
              (click)="displayDuplicateGuestModal()"
            ></span>
          </host-input-with-error>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label">
        {{ "component.sidebar.order_form_item_mobile" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative">
          <input
            nz-input
            nzSize="large"
            type="phone"
            [readonly]="isExistedGuest"
            [attr.placeholder]="'placeholder.mobile_optional' | translate"
            (compositionstart)="compositionstart('mobile')"
            (compositionend)="compositionend('mobile')"
            (input)="checkIfHasDuplicateGuest('mobile')"
            formControlName="mobile"
          />
          <span class="guest-icon" [class.highlight]="hasDuplicateGuest" (click)="displayDuplicateGuestModal()"></span>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label require">
        {{ "component.sidebar.order_form_item_checkin_time" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-input-with-error
            class="w-full"
            [showError]="checking && form.get('hour_reservation_start').invalid"
            [i18nErrorKey]="'component.sidebar.order_form_item_checkin_time'"
            [errorText]="'入住时间'"
          >
            <nz-time-picker
              nzSize="large"
              formControlName="hour_reservation_start"
              [nzHideDisabledOptions]="true"
              [nzMinuteStep]="5"
              [nzFormat]="nzFormat"
            ></nz-time-picker>
          </host-input-with-error>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label require">
        {{ "component.sidebar.order_form_item_checkout_time" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-input-with-error
            class="w-full"
            [showError]="checking && form.get('hour_reservation_start').invalid"
            [i18nErrorKey]="'component.sidebar.order_form_item_checkout_time'"
            [errorText]="'入住时间'"
          >
            <nz-time-picker
              nzSize="large"
              formControlName="hour_reservation_end"
              [nzHideDisabledOptions]="true"
              [nzMinuteStep]="5"
              [nzFormat]="nzFormat"
            ></nz-time-picker>
          </host-input-with-error>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label require">
        {{ "component.sidebar.order_form_item_channel" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-input-with-error
            class="w-full"
            [i18nErrorKey]="'placeholder.channel'"
            [showError]="checking && form.get('channel').invalid"
          >
            <nz-select
              nzSize="large"
              formControlName="channel"
              [nzPlaceHolder]="'placeholder.siderbar.order_channel' | translate"
            >
              <nz-option
                *ngFor="let channel of listOfChannels"
                [nzLabel]="channel.channel_name"
                [nzValue]="channel.code"
              ></nz-option>
            </nz-select>
          </host-input-with-error>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label">
        {{ "order.house_fee" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            nz-input
            nzSize="large"
            type="number"
            [attr.placeholder]="'component.sidebar.hr.placeholder.house_fee' | translate"
            formControlName="price"
          />
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label">
        {{ "component.sidebar.order_form_item_commission" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            nz-input
            nzSize="large"
            type="number"
            [attr.placeholder]="'placeholder.amount_optional' | translate"
            formControlName="commission"
          />
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label">
        {{ "component.sidebar.order_form_item_currency" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-select nzSize="large" formControlName="currency_type">
            <nz-option *ngFor="let currency of listOfCurrency" [nzLabel]="currency" [nzValue]="currency"></nz-option>
          </nz-select>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form" [formGroup]="form" *ngIf="houseFee">
    <div class="v4-layout-form-title">
      {{ "component.sidebar.order_form_title_collection" | translate }}
    </div>

    <div class="v4-layout-field">
      <span class="v4-layout-field-label">
        {{ "component.sidebar.order_form_item_collected_fee" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            #paidAmount
            type="number"
            nzSize="large"
            nz-input
            formControlName="paid_amount"
            [attr.placeholder]="'component.sidebar.hr.placeholder.received' | translate"
            (focus)="onInputFocus()"
            class="input"
          />
        </div>
      </div>
    </div>

    <div class="v4-layout-field" *ngIf="form.get('paid_amount').value > 0">
      <span class="v4-layout-field-label require">
        {{ "component.sidebar.order_form_item_payment_method" | translate }}
      </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-input-with-error
            class="w-full"
            [showError]="checking && form.get('payment_method').value === null"
            [i18nErrorKey]="'placeholder.siderbar.payment_method'"
          >
            <nz-select
              nzSize="large"
              [nzPlaceHolder]="'placeholder.siderbar.payment_method' | translate"
              formControlName="payment_method"
            >
              <nz-option
                *ngFor="let method of listOfIncomeMethod"
                [nzLabel]="method.method_name"
                [nzValue]="method.code"
              ></nz-option>
            </nz-select>
          </host-input-with-error>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form" [formGroup]="form">
    <ng-container *ngIf="noteStatus === 'none'">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <a nz-button nzType="link" (click)="noteStatus = 'editing'">
            +{{ "component.sidebar.order_form_item_add_mark" | translate }}
            <!-- +添加订单备注 -->
          </a>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="noteStatus === 'editing'">
      <div class="v4-layout-form-title">
        <div class="flex flex-row items-center justify-between">
          {{ "component.sidebar.order_form_title_mark" | translate }}
          <!-- 订单备注 -->
          <a nz-button nzType="link" (click)="noteStatus = 'none'">
            {{ "word.cancel" | translate }}
            <!-- 取消 -->
          </a>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <textarea
            class="row-input input"
            nz-input
            formControlName="note"
            [attr.placeholder]="'placeholder.input_remarks' | translate"
            rows="4"
          ></textarea>
        </div>
      </div>
    </ng-container>
  </div>

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzSize="large" nzType="primary" (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>
